const TextInterpolator: React.FunctionComponent<{ text: string }> = (props) => {
  return <>{props.text}</>;
};

export default TextInterpolator;
